import React from 'react';
import { Grid, LeftColumnGridCell, RightColumnGridCell } from 'styles';
import { ContactSupport } from 'components/modules/contact-support';
import { PageHeading } from 'components/page-heading';
import { StateSolarFarms } from 'pages/solar/components/state-solar-farms';
import { EnergyBreakdown } from 'pages/solar/components/energy-breakdown';
import { SolarNotification } from 'pages/solar/components/solar-notification';
import { ReconnectUtilityNotification } from 'pages/solar/components/reconnect-utility-notification';

export const Ineligible = ({
  pageHeading,
  stateFullName,
  stateId,
  zipCode,
  vnmSolarProjectsStatistics,
}: SolarActiveViewProps) => {
  return (
    <>
      <PageHeading page={pageHeading} />
      <ReconnectUtilityNotification />
      <SolarNotification />
      <Grid width="100%" gap="24px">
        <LeftColumnGridCell>
          <StateSolarFarms
            stateId={stateId}
            stateFullName={stateFullName}
            vnmSolarProjectsStatistics={vnmSolarProjectsStatistics}
          />
        </LeftColumnGridCell>
        <RightColumnGridCell>
          <EnergyBreakdown
            zipCode={zipCode}
            small={{ margin: { top: '0px' } }}
          />
          <ContactSupport margin={{ top: '24px' }} />
        </RightColumnGridCell>
      </Grid>
    </>
  );
};
